import styled from 'styled-components';

export const Modal = styled.div`
  cursor: initial;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99999;
  background-color: ${(props) => props.theme.colors.overlay};
  backdrop-filter: blur(2px);
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  background-color: ${(props) => props.theme.colors.card};
  width: 30%;
  height: 30%;
  overflow-y: auto;
  padding: ${(props) => props.theme.spacing.lg} 5vw;
  border-radius: ${(props) => props.theme.radii.lg};
  z-index: 999999;
  box-shadow: ${(props) => props.theme.shadows.base};
  border: 1px solid ${(props) => props.theme.colors.border};
`;

export const Text = styled.div`
  display: flex;
  justify-content: center;
  font-weight: ${(props) => props.theme.fontWeights.medium};
  font-size: ${(props) => props.theme.fontSizes.xxl};
  color: ${(props) => props.theme.colors.textPrimary};
`;

export const Button = styled.button`
  display: flex;
  width: 40%;
  height: 150%;
  color: ${(props) => props.theme.colors.textInverse};
  text-transform: uppercase;
  border-radius: ${(props) => props.theme.radii.lg};
  border: 1px solid ${(props) => props.color || props.theme.colors.label};
  font-weight: ${(props) => props.theme.fontWeights.bold};
  font-size: ${(props) => props.theme.fontSizes.lg};
  align-items: center;
  justify-content: center;
  background: ${(props) => props.color || props.theme.colors.label};
  cursor: pointer;
  transition: all ${(props) => props.theme.transitions.base};

  :hover {
    background: ${(props) => props.theme.colors.card};
    color: ${(props) => props.color || props.theme.colors.label};
  }

  :focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.focus};
    outline-offset: 2px;
  }
`;

export const Line = styled.div`
  justify-content: space-between;
  display: flex;
`;

export const ButtonClose = styled.button`
  width: 34px;
  height: 34px;
  border-radius: ${(props) => props.theme.radii.lg};
  background: ${(props) => props.theme.colors.disabled};
  color: ${(props) => props.theme.colors.label};
  font-weight: ${(props) => props.theme.fontWeights.bold};
  font-size: ${(props) => props.theme.fontSizes.xs};
  border: none;
  transition: transform ${(props) => props.theme.transitions.fast};

  :hover {
    cursor: pointer;
    transform: scale(1.1);
  }
`;

export const Elemento = styled.div`
  position: ${(props) => (props.position ? props.position : '')};
  display: flex;
  flex-direction: ${(props) => (props.direction ? props.direction : 'column')};
  flex-wrap: ${(props) => (props.wrap ? props.wrap : '')};
  margin-bottom: ${(props) => (props.wrap ? props.wrap : '26vh')};
  justify-content: ${(props) => (props.justify ? props.justify : '')};
  align-items: ${(props) => (props.align ? props.align : '')};
  width: ${(props) => (props.width ? props.width : '')};
`;
